import React, { useState } from 'react'

import { Row, Col } from 'react-bootstrap';
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import { MdLink } from 'react-icons/md';

const initial = '';

const LinkDialog = props => {
  const [ searchValue, setSearchValue ] = useState(initial);
  const [ searchResults, setSearchResults ] = useState([]);
  const { onLink, open, setOpen, selected, surveys } = props

  const [switchState, setSwitchState] = React.useState({
    addMultiple: false,
  })

  const handleSwitchChange = name => event => {
    setSwitchState({ ...switchState, [name]: event.target.checked })
  }

  const resetSwitch = () => {
    setSwitchState({ addMultiple: false })
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    resetSwitch()
  }

  const handleLink = (target) => {
    onLink(target, selected);
    setSearchValue(initial)
    switchState.addMultiple ? setOpen(true) : setOpen(false)
  }

  const handleChange = ({ target: { value } }) => {
    setSearchValue(value);
    const results = surveys.filter(s => s.label.toLowerCase().includes(value.toLowerCase()));
    setSearchResults(results);
  }

  return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Link question</DialogTitle>
        <DialogContent>
          <DialogContentText>Link question to survey.</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Search Surveys"
            type="text"
            fullWidth
            value={searchValue}
            onChange={handleChange}
          />
          {searchResults.map((item, index) => (
            <Row key={"search-result-" + index} className="py-2 align-items-center">
                <Col xs={2}>
                    <Button onClick={() => handleLink(item)} color="primary"><MdLink /></Button>
                </Col>
                <Col xs={6}>
                    {item.label}
                </Col>
            </Row>
          ))}
         </DialogContent>
        <DialogActions>
          <Tooltip title="Link to multiple">
            <Switch
              checked={switchState.addMultiple}
              onChange={handleSwitchChange('addMultiple')}
              value="addMultiple"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          </Tooltip>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
  )
}

LinkDialog.propTypes = {
  onLink: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  surveys: PropTypes.array.isRequired,
}

export default LinkDialog
